import React from 'react'
import Dropdown from './Dropdown'
import {sortBy} from 'lodash'

class SelectLocOrg extends React.Component {
  render() {
    return (
      <div className="dropdown-container">
        <Dropdown
          dlClassNames=''
          controlWidth={2}
          value={this.props.location}
          data={sortBy(this.props.locations, "name")}
          placeholder='Kies locatie'
          id='location_selector'
          textField='name'
          disabled={this.props.disabled}
          onChange={(e) => this.props.locationChange(e)} />

        <Dropdown
          dlClassNames=''
          controlWidth={2}
          value={this.props.unit}
          data={sortBy(this.props.units, "name")}
          placeholder='Kies organisatorische eenheid'
          id='unit_selector'
          textField='name'
          disabled={this.props.disabled}
          onChange={(e) => this.props.unitChange(e)} />
      </div>
    )
  }
}

export default SelectLocOrg



// WEBPACK FOOTER //
// ./src/components/SelectLocOrg.js